import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
};

export default function AdminList({ endpoint, columns, testid, empty }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let active = true;
    api.get(endpoint).then((r) => active && setRows(r.data)).catch(() => active && setRows([]));
    return () => { active = false; };
  }, [endpoint]);

  if (rows === null)
    return <div className="p-16 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-secondary" /></div>;

  return (
    <div className="border border-border rounded-xl overflow-x-auto" data-testid={testid}>
      <div className="min-w-[720px]">
        <div className="grid px-5 py-3 bg-card text-[11px] uppercase tracking-widest text-muted-foreground border-b border-border"
             style={{ gridTemplateColumns: columns.map((c) => c.w || "1fr").join(" ") }}>
          {columns.map((c) => <div key={c.key}>{c.label}</div>)}
        </div>
        {rows.length === 0 ? (
          <div className="p-16 text-center text-muted-foreground">{empty}</div>
        ) : (
          rows.map((r) => (
            <div key={r.id} data-testid={`${testid}-row`}
                 className="grid px-5 py-4 border-b border-border last:border-0 hover:bg-card/60 transition-colors items-center text-sm"
                 style={{ gridTemplateColumns: columns.map((c) => c.w || "1fr").join(" ") }}>
              {columns.map((c) => (
                <div key={c.key} className={c.muted ? "text-muted-foreground truncate pr-3" : "truncate pr-3"}>
                  {c.key === "created_at" ? fmtDate(r[c.key]) : c.render ? c.render(r) : (r[c.key] ?? "—")}
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
